import { ApiError } from '@/api/client';

/**
 * The line shown when the search request itself fails (as opposed to a directory
 * inside a successful response failing, which the API reports per source).
 * Never empty for a failure: a blank result must not read as "nothing found".
 */
export function describeSearchError(err: unknown): string | null {
  if (!err) return null;
  if (err instanceof ApiError) {
    return err.kind === 'auth' ? 'You do not have access to this search.' : err.message;
  }
  return 'Something went wrong running the search.';
}
